<template>
	<div class="legendWrapper" v-click-outside="closeLegend">
		<div class="legendButton" @click="toggleLegendList">Legend</div>
		<div class="legendList" :class="showLegendList">
			<div class="legendItem" v-for="(category, index) in colourSet.order" :key="index">
				<div class="color" :style="{ backgroundColor: colourSet.colors[index] }"></div>
				{{ category }}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import vOutsideEvents from 'vue-outside-events';

Vue.use(vOutsideEvents);
export default {
    name: 'chartLegend',
    data () {
        return {
            showLegend: false,
        };
    },
    methods: {
        toggleLegendList () {
            this.showLegend = !this.showLegend;
        },
        closeLegend () {
            this.showLegend = false;
        },
    },
    computed: {
        showLegendList () {
            return this.showLegend ? 'show' : '';
        },
        colourSet () {
            const colList = this.$store.state.chart.colourSelection;
            const currentSet = this.$store.state.universe.data.categoryDimensions.findIndex(i => i.name === colList);
            return currentSet > -1
                ? this.$store.state.universe.data.categoryDimensions[currentSet]
                : this.$store.state.universe.data.categoryDimensions[0];
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "src/assets/scss/all.scss";
.legendWrapper {
	display: inline-block;
	position: relative;
	vertical-align: middle;
	margin-right: 5px;
	.legendButton {
		background: $darkBlue;
		border-radius: 6px;
		color: white;
		cursor: pointer;
		padding: 6px 12px;
		text-align: center;
	}
	.legendList {
		-moz-border-radius: 0.4167rem;
		-ms-border-radius: 0.4167rem;
		-o-border-radius: 0.4167rem;
		-webkit-border-radius: 0.4167rem;
		background-color: white;
		border-radius: 0.4167rem;
		border: 2px solid $darkBlue;
		box-shadow: 0 9px 23px rgba(0, 0, 0, 0.09), 0 5px 5px rgba(0, 0, 0, 0.06) !important;
		display: none;
		padding: 10px;
		position: absolute;
		right: -370px;
		top: 50px;
		width: 850px;
		z-index: 1;
		@include easeInOut(0.5s);
		&:after,
		&:before {
			border: solid transparent;
			bottom: 100%;
			content: " ";
			height: 0;
			pointer-events: none;
			position: absolute;
			width: 0;
		}
		&.show {
			display: block;
		}
		.legendItem {
			float: left;
			margin-bottom: 10px;
			width: 33%;
			.color {
				border-radius: 10px;
				float: left;
				height: 20px;
				margin-right: 10px;
				width: 20px;
			}
		}
	}
}
</style>
